"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.topPosition = topPosition;
function topPosition(domElt) {
  if (!domElt) {
    return 0;
  }
  return domElt.offsetTop + topPosition(domElt.offsetParent);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-infinite-scroll/lib/Utilities/DOMPositionUtils.js
// module id = 874
// module chunks = 0